import Parser from "rss-parser";
import {BASE_URL} from "../../baseUrls";

export const GET_RSS_NEWS = 'RSS_NEWS'

export function getRssNews(callback = () => {}) {
  return function(dispatch, getState) {
    const url = `${ BASE_URL }/blog/category/lifenaut-users/feed/`;
    const parser = new Parser();
    parser.parseURL(url)
      .then((rssFeed) => {
        const data = !!rssFeed?.items?.[0]?.pubDate ? rssFeed.items[0] : {skip: true, pubDate: 0};
        dispatch({
          type: GET_RSS_NEWS,
          payload: data,
        })
      }).catch((e) => {
        const data = !BASE_URL.toLowerCase().includes("naut") ?
          {name:'Test News 2', link:'#', title: 'Breakthrough in Data Storage!', content: `<p><img
              src="https://www.testnaut.net/wp-content/uploads/2022/05/ab561ab79fff9aa9611d400f43711e50.jpg"
              className="attachment-full size-full wp-post-image" alt=""
              srcSet="https://www.testnaut.net/wp-content/uploads/2022/05/ab561ab79fff9aa9611d400f43711e50.jpg 450w, https://www.testnaut.net/wp-content/uploads/2022/05/ab561ab79fff9aa9611d400f43711e50-150x113.jpg 150w, https://www.testnaut.net/wp-content/uploads/2022/05/ab561ab79fff9aa9611d400f43711e50-300x225.jpg 300w"
              sizes="(max-width: 450px) 100vw, 450px" width="450" height="338" ></p>
              <p>From Future Time Line: &nbsp;Japanese Scientists announce a breakthrough in data storage using
                Ultra-Pure Diamonds. Engineers have developed a way to mass-produce diamond wafers that could store (25
                Exabytes) the equivalent of a billion Blu-ray disks on a single
                device. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; […]</p>
              <p>The post <a rel="nofollow" href="https://www.testnaut.net/blog/breakthrough-in-data-storage/">Breakthrough
                in Data Storage!</a> appeared first on <a rel="nofollow" href="https://www.testnaut.net">LifeNaut</a>.
              </p>`
            , pubDate: new Date(170000).toString()}
          : {skip: true, pubDate: 0};
        dispatch({
          type: GET_RSS_NEWS,
          payload: data,
        })
      })
    .finally(() => callback());
  }
}

export function rssNews(state = {skip: true, pubDate: 0}, action) {
  switch (action.type) {
    case GET_RSS_NEWS:
      return {...action.payload, content:(action.payload.content||"").replaceAll(/&nbsp;( &nbsp;)* &nbsp; ?/g, "")};
    default:
      return  state;
  }
}
